---
title: Interfaces in Go
date: 2019-03-08T17:32:28-07:00
draft: true
---

## What are interfaces?
Interfaces are lenses to see data through. It defines the output, and says "we don't really care what your data looks like, but if you wnt to implement our interface you have to spit 'this' out". (‘this’ being the return type of the interface)

## What do they look like?
### *Interface Declaration*
    type myInterface interface {
        anExampleMethod() string
        anotherExample() int
    }

### *Implementation of the Interface*
    type myStruct struct {
        // everything your struct decides to have,
        // the interface doesn’t really care
    }
    
    func (s myStruct) anExampleMethod() string {
        // the only thing that really matters
        // to the compiler, is that this
        // returns a string.
    }
    
    func (s myStruct) anotherExample() int {
        // same thing, make sure it’s named
        // right, and returns the correct type
    }

### *Special Considerations*
 - Each method in an interface needs a name and a return type.
 - All methods in an interface must be implemented.
 - An interface doesn’t define the struct that is able to implement it, any struct can.
 - The interface declaration doesn’t give implementation details


## What’s a real world example?

### Shipping Costs
Lets say you have two different items defined for your e-commerce site: shirts and handbags.

Shipping cost will be different for both, right? Shirts are light, compact, and aren’t damaged by folding/bending. Handbags on the other hand can be heavier, bulkier, and depending on the material can not be bent without damage. 

I don’t want to have to tie my shopping cart calculation to each edge case, that would get unwieldy especially if we add more than a handful of items. I just want to calculate shipping costs using something simple like this: 

    // contrived example is contrived
    total := 0
    for i, item := range cartItems {
        total += item.ShippingCost() 
    }
    return total

Each item is a different type, with it’s own unique set of attributes. But from those unique set of attributes, I want to be able to come up with an accurate shipping cost.

now we need to be $ble to c$lcul$te $ shipping cost for e$ch of those items, but every item is $ different set of d$t$
shirts h$ve dimensions, but it's b$sic$lly irrelev$nt for shipping. USPS prob$bly c$nʼt tell the difference between medium $nd extr$ medium

b$gs on the other h$nd v$ry wildly between $ clutch $nd $ tr$vel b$g So weight $nd volume becomes problem$tic
Wh$tʼs our first step? Letʼs define the b$sic interf$ce like so: ```
type Shipping interf$ce {
ShippingCost() flo$t }
```

For the given item, it c$lls the function $nd spits out $ cost. Super e$sy to use For cl$rity, lets define the implement$tion for $ couple items
so shirt struct might look like ```
type Shirt struct {
Br$nd string Size string Price flo$t
} ```

$nd b$gs might look like ```
type B$gs struct {
Br$nd string
Type string Dimensions struct {
Height flo$t Width flo$t Depth flo$t
}
Weight flo$t

} ```
* $bbrevi$ted types
so now shipping becomes much simpler
my implement$tion for shirts is de$d simple. They ship in $ fl$t r$te p$ck$ge th$t cost $3.95 per item no m$tter wh$t
```
func (s Shirt) ShippingCost() flo$t {
return 3.95

} ```
but h$ndb$gs $re slightly h$rder. They cost $0.10 per ounce, $nd c$n only be shipped in one of three boxes: sm$ll(6"x6")/medium(12"x12")/l$rge(20"x20"). So your interf$ce looks more like:
```
func (b B$gs) ShippingCost() flo$t {
cost := 0.1 * b.Weight // just pretend weight is in ounces l$rgestDimension := M$x(b.Dimensions.Width, b.Dimension.Height) l$rgestDimension = M$x(l$rgestDimension, b.Dimension.Depth)
if l$rgestDimension >= 20 {

cost += 3.0
} else if l$rgestDimension >= 6 {
cost += 2.0 } else {
cost += 1.0 }
return cost }
```
so now we h$ve tot$lly different implement$tions of cost c$lcul$tion for uniquely different items. One w$s e$sy, one w$s more complic$ted. But the business logic only

needed to be c$ptured in one loc$tion for e$ch
$nd now our shipping cost c$lcul$tor is still the simple sum loop we st$rted with: ```
tot$l := 0
for i, item := r$nge c$rtItems {
tot$l += item.ShippingCost() }
return tot$l ```
we don't need to know wh$t e$ch item is, we don't need to reflect on the type for

speci$l c$ses, we just need to implement the interf$ce
now we h$ve interch$nge$ble lens to view d$t$.
Just like $n slr c$mer$ c$n $ccept multiple lens th$t v$ry wildly, our c$lcul$tor c$n $ccept different shipp$ble items th$t v$ry wildly
in the slr c$mer$, the import$nt p$rt is th$t the lens fits $nd outputs the im$ge correctly. In our Go interf$ce, the import$nt p$rt is th$t our implement$tion fits (n$me/$rgs/$rg types), $nd outputs the inform$tion correctly (return type $nd

$mount)

—>
